//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['countries', 'billingAddress', 'loggedIn'],
  data() {
    return {
      showShippingAddress: false,
      createAccount: true,
      actualCountry: 'CZ',
      shippingMethods: [],
      currency: 'czk',
    };
  },
  methods: {
    toggleShippingAddress(value) {
      this.showShippingAddress = value;
    },
    changeCountry(code) {
      this.actualCountry = code;
      fetch('/?wc-ajax=shippingmethods', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          country: this.actualCountry,
          currency: this.currency,
        }),
      })
        .then(response => response.json())
        .then(data => (this.shippingMethods = data));
    },
    changeCurrency(currency) {
      this.currency = currency;
      this.changeCountry(this.actualCountry);
      if (currency == 'czk') {
        $('.eur-price').hide();
        $('.czk-price').show();
      } else {
        $('.czk-price').hide();
        $('.eur-price').show();
      }
    },
    changeCreateAccount(value) {
      this.createAccount = value;
    },
  },
  mounted() {
    if (this.billingAddress) {
      this.changeCountry(this.billingAddress.country);
      this.changeCurrency(this.billingAddress.currency.toLowerCase());
    } else {
      this.changeCountry('CZ');
      this.changeCurrency('czk');
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/checkout/App.vue